/**
 * @file Dictionnaire FRANCAIS : meme jeu de cles que EN (verifie par le compilateur : Record<TranslationKey, string>).
 */
import type { TranslationKey } from './en';

export const FR: Record<TranslationKey, string> = {
  'app.title': "Cat Gunner",
  'common.ok': "OK",
  'common.cancel': "Annuler",
  'common.close': "Fermer",
  'common.claim': "Récupérer",
  'common.claimed': "Récupéré",
  'common.buy': "Acheter",
  'common.equip': "Équiper",
  'common.equipped': "Équipé",
  'common.locked': "Verrouillé",
  'common.unlockAt': "Débloqué au stage {stage}",
  'common.free': "Gratuit",
  'common.max': "MAX",
  'common.level': "Niv {level}",
  'common.back': "Retour",
  'common.confirm': "Confirmer",
  'common.continue': "Continuer",
  'common.x2': "x2",
  'currency.money': "Argent",
  'currency.ruby': "Rubis",
  'currency.dia': "Gemmes",
  'currency.petCoin': "Pièces de familier",
  'currency.starGem': "Gemmes étoile",
  'currency.coreForest': "Noyaux de forêt",
  'currency.coreDesert': "Noyaux du désert",
  'currency.coreTundra': "Noyaux de toundra",
  'currency.wood': "Bois",
  'currency.stone': "Pierre",
  'currency.ironOre': "Minerai de fer",
  'currency.copperOre': "Minerai de cuivre",
  'currency.silverOre': "Minerai d'argent",
  'currency.goldOre': "Minerai d'or",
  'currency.crystal': "Cristal",
  'upgrade.power': "Puissance",
  'upgrade.speed': "Vitesse",
  'upgrade.money': "Argent",
  'upgrade.power.desc': "Dégâts x1,08 par niveau",
  'upgrade.speed.desc': "Cadence +8 % par niveau",
  'upgrade.money.desc': "Gains x1,08 par niveau",
  'upgrade.buyMax': "Acheter max",
  'upgrade.gainLevels': '+{n} niv.',
  'stat.damage': "Dégâts",
  'stat.attackSpeed': "Cadence",
  'stat.money': "Gains",
  'stat.critChance': "Chance de critique",
  'stat.critDamage': "Dégâts critiques",
  'stat.moveSpeed': "Vitesse de déplacement",
  'stat.range': "Portée",
  'stat.offlineHours': "Plafond hors-ligne (h)",
  'stat.offlineRate': "Efficacité hors-ligne",
  'stat.rebirthGain': "Gain de rubis",
  'stat.diaGain': "Gain de gemmes",
  'stat.petCoinGain': "Gain de pièces de familier",
  'stat.xpGain': "Gain d'XP",
  'stat.harvestYield': "Rendement de récolte",
  'stat.rareTreeChance': "Chance d'arbre rare",
  'stat.dps': "DPS",
  'hud.stage': "Stage {stage}-{level}",
  'hud.boss': "BOSS",
  'hud.wave': "Vague {wave}/{max}",
  'hud.challenge': "Défi",
  'hud.farming': "Récolte libre",
  'hud.autoMove': "Déplacement auto",
  'hud.autoFire': "Tir auto",
  'hud.stageClear': "Stage réussi !",
  'hud.levelFailed': "Temps écoulé !",
  'hud.ready': "Prêt...",
  'hud.go': "Go !",
  'hud.barrier': "Barrière",
  'hud.exitMode': "Quitter",
  'menu.weapons': "Armes",
  'menu.skins': "Skins",
  'menu.rebirth': "Renaissance",
  'menu.missions': "Missions",
  'menu.modes': "Modes",
  'menu.settings': "Réglages",
  'menu.daily': "Cadeau",
  'menu.hub': "Hub",
  'feature.hub': "Hub social",
  'menu.tickets': "Tickets",
  'weapons.title': "Armes",
  'weapons.tab.inventory': "Coffre",
  'weapons.tab.collection': "Collection",
  'weapons.tab.stars': "Étoiles",
  'weapons.drawNormal': "Tirage",
  'weapons.drawEpic': "Tirage épique",
  'weapons.drawTen': "x{n}",
  'weapons.dailyFree': "Arme gratuite du jour",
  'weapons.merge': "Fusionner",
  'weapons.autoMerge': "Fusion auto",
  'weapons.lock': "Verrouiller",
  'weapons.unlock': "Déverrouiller",
  'weapons.slot': "Emplacement {n}",
  'weapons.chest': "Coffre {count}/{cap}",
  'weapons.chestEmpty': "Ton coffre est vide : tire une arme ci-dessus !",
  'weapons.buySlot': "Emplacement en plus",
  'weapons.dps': "{dps} DPS",
  'weapons.collectionReward': "Compléter le grade {grade}",
  'weapons.mergeHint': "Glisse une arme sur une autre arme du même grade pour les fusionner (y compris une arme équipée : choisis alors Fusionner ou Équiper). Glisse une arme sur un emplacement pour l'équiper, ou d'un emplacement vers le coffre pour la retirer.",
  'behavior.single': "Simple",
  'behavior.pierce': "Perforant",
  'behavior.shotgun': "Fusil à pompe",
  'behavior.explosive': "Explosif",
  'behavior.laser': "Laser",
  'behavior.missile': "Missile",
  'behavior.blastSniper': "Laser explosif",
  'stars.title': "Amélioration étoiles",
  'stars.chance': "Réussite {chance}",
  'stars.upgrade': "Améliorer ({cost})",
  'stars.success': "Réussi !",
  'stars.fail': "Échec...",
  'skins.title': "Skins",
  'skins.bonusHint': "Les bonus s'appliquent même si le skin n'est pas équipé.",
  'rebirth.title': "Renaissance",
  'rebirth.desc': "Recommence au stage 1-1 et gagne des rubis. Armes, skins et gemmes sont conservés.",
  'rebirth.gain': "Tu gagneras {rubies} rubis",
  'rebirth.do': "Renaître",
  'rebirth.doX3': "Renaissance x3 (quotidienne)",
  'rebirth.notYet': "Gagne plus d'argent avant de renaître.",
  'rebirth.bonus.damage': "Dégâts permanents",
  'rebirth.bonus.attackSpeed': "Cadence permanente",
  'rebirth.bonus.money': "Gains permanents",
  'rebirth.confirm': "Renaître maintenant ? Ton stage et tes améliorations seront remis à zéro.",
  'missions.title': "Missions",
  'missions.daily': "Quotidiennes",
  'missions.weekly': "Hebdomadaires",
  'missions.achievements': "Succès",
  'missions.resetIn': "Réinitialisation dans {time}",
  'pass.title': "Passe de saison",
  'pass.tier': "Palier {tier}",
  'pass.free': "Gratuit",
  'pass.epic': "Épique",
  'pass.unlockEpic': "Débloquer la piste épique",
  'pass.endsIn': "La saison se termine dans {time}",
  'daily.title': "Cadeau du jour",
  'daily.day': "Jour {day}",
  'modes.title': "Modes de jeu",
  'modes.tickets': "{n} tickets",
  'modes.nextTicket': "Prochain dans {time}",
  'modes.best': "Record : {best}",
  'modes.play': "Jouer",
  'modes.sweep': "Balayage",
  'modes.skeleton': "Aperçu",
  'mode.main.title': "Stage",
  'mode.monster.title': "Défense des monstres",
  'mode.speedRun.title': "Contre-la-montre",
  'mode.mine.title': "Mine",
  'mode.boss.title': "Boss errant",
  'mode.raid.title': "Raid",
  'mode.adventure.title': "Aventure",
  'mode.fish.title': "Aquarium",
  'mode.harvest.title': "Récolte",
  'mode.hub.title': "Place des chats",
  'mode.result.win': "Victoire !",
  'mode.result.lose': "Défaite",
  'buff.moneyBuff': "Argent x3",
  'buff.powerBuff': "Puissance x3",
  'buff.speedBuff': "Vitesse x3",
  'buff.activate': "Activer",
  'buff.freeIn': "Gratuit dans {time}",
  'offline.title': "Pendant ton absence",
  'offline.duration': "Absent pendant {time}",
  'offline.capped': "Plafond hors-ligne atteint !",
  'offline.earned': "Tes chats ont gagné {money}",
  'offline.kills': "{kills} arbres abattus",
  'offline.double': "x2 pour {cost} gemmes",
  'settings.title': "Réglages",
  'settings.language': "Langue",
  'settings.sound': "Son",
  'settings.music': "Musique",
  'settings.mute': "Muet",
  'settings.eco': "Mode éco",
  'settings.quality': "Qualité",
  'settings.quality.low': "Basse",
  'settings.quality.high': "Haute",
  'settings.quality.hint': "Basse : image plus légère (1x au lieu de 2x), sans halo lumineux, moins de particules. Plus fluide et moins gourmand en batterie.",
  'settings.autoLowQuality': "Halo lumineux coupé pour cette session afin de garder le jeu fluide.",
  'settings.vibration': "Vibrations",
  'settings.damageNumbers': "Chiffres de dégâts",
  'settings.fxSelf': "Mes effets (aura, tirs, feux d'artifice)",
  'settings.fxOthers': "Effets des autres joueurs",
  'settings.reduceMotion': "Réduire les animations",
  'settings.autoMove': "Déplacement auto",
  'settings.autoFire': "Tir auto",
  'settings.autoUpgrade': "Amélioration auto",
  'settings.resetSave': "Effacer la sauvegarde",
  'settings.resetConfirm': "Effacer toute la progression ? Action irréversible.",
  'settings.export': "Exporter la sauvegarde",
  'settings.import': "Importer une sauvegarde",
  'tutorial.upgrade': "Touche PUISSANCE pour rendre ton chat plus fort !",
  'tutorial.chop': "Ton chat tire tout seul : abats {n} arbres pour gagner de l'argent ! ({done}/{n})",
  'tutorial.gunOpen': "Ouvre le menu ARMES.",
  'tutorial.gunBuy': "Tire une nouvelle arme avec tes gemmes.",
  'tutorial.gunEquip': "Équipe ta nouvelle arme : un chat par arme !",
  'tutorial.skip': "Passer le tutoriel",
  'toast.unlocked': "Débloqué : {name}",
  'toast.saved': "Partie sauvegardée",
  'toast.newWeapon': "Nouvelle arme : {name}",
  'toast.merged': "Fusion : {name} !",
  'toast.mergedAuto': "Fusion auto : {name} (grade {grade})",
  'toast.rebirth': "Renaissance ! +{rubies} rubis",
  'toast.missionDone': "Mission accomplie !",
  'toast.cloudLoaded': 'Sauvegarde cloud chargée (plus récente que celle de cet appareil).',
  'toast.loadFailed': "La sauvegarde n'a pas pu être chargée, une copie de secours a été utilisée.",
  'error.notEnoughFunds': "Pas assez de ressources",
  'error.locked': "Verrouillé",
  'error.maxLevel': "Niveau maximum atteint",
  'error.invalidTarget': "Cible invalide",
  'error.inventoryFull': "Le coffre est plein",
  'error.cannotMerge': "Ces armes ne peuvent pas être fusionnées",
  'error.notOwned': "Non possédé",
  'error.alreadyOwned': "Déjà possédé",
  'error.cooldown': "Pas encore disponible",
  'error.noTickets': "Plus de tickets",
  'error.wrongMode': "Indisponible dans ce mode",
  'error.unknownId': "Objet inconnu",
  'error.invalidArgument': "Action invalide",
  'error.nothingToClaim': "Rien à récupérer",
  'feature.weapons': "Armes",
  'feature.gacha': "Tirages d'armes",
  'feature.chest': "Coffre",
  'feature.skins': "Skins",
  'feature.missions': "Missions",
  'feature.pass': "Passe de saison",
  'feature.daily': "Cadeau du jour",
  'feature.buffs': "Bonus temporaires",
  'feature.rebirth': "Renaissance",
  'feature.stars': "Amélioration étoiles",
  'feature.relics': "Reliques",
  'feature.pets': "Familiers",
  'feature.fish': "Aquarium",
  'feature.modeSelect': "Modes de jeu",
  'feature.autoMerge': "Fusion auto",
  'common.unlockRebirths': "Débloqué après {n} renaissances",
  'weapons.unequip': "Retirer",
  'weapons.mergeAll': "Tout fusionner",
  'weapons.drawResult': "Tu as obtenu !",
  'weapons.tapToClose': "Touche pour continuer",
  'weapons.noWeapon': "Vide",
  'weapons.selectHint': "Touche une arme puis un emplacement pour l'équiper.",
  'weapons.detail.grade': "Grade {grade}",
  'weapons.detail.mergeTo': "Fusionner → {grade}",
  'weapons.detail.hint': "Touche un emplacement pour l'y équiper, ou glisse l'arme.",
  'weapons.detail.freeSlot': "Emplacement {n} libre : équipe-la !",
  'weapons.detail.vsSlot': "{delta} de DPS par rapport à l'emplacement {n}",
  'weapons.detail.sameAs': "Même DPS que l'emplacement {n}",
  'weapons.detail.inSlot': "Équipée dans l'emplacement {n}",
  'stars.level': "Niveau d'étoiles {level}/{max}",
  'stars.multiplier': "Puissance de l'emplacement {mult}",
  'stars.noWeapon': "Équipe d'abord une arme dans cet emplacement.",
  'pass.xp': "{xp} XP",
  'daily.comeBack': "Reviens demain !",
  'missions.empty': "Aucune mission pour l'instant.",
  'rebirth.count': "Renaissances : {n}",
  'settings.copy': "Copier",
  'settings.copied': "Copié !",
  'settings.importHint': "Colle une sauvegarde ici...",
  'settings.importFailed': "Cette sauvegarde n'a pas pu être importée.",
  'settings.debug': "Debug (GPU)",
  'skins.total': "Bonus total des skins",
  'skins.confirmGems': "Dépenser des gemmes pour ce skin ?",
  'skins.tab.cats': "Chats",
  'skins.tab.ammo': "Munitions",
  'skins.tab.shotfx': "FX de tir",
  'skins.tab.pets': "Familiers",
  'pets.hint': "Achète des familiers avec les pièces gagnées en mode Monstres. Jusqu'à 3 équipés : leur bonus s'applique tant qu'ils sont équipés. Touche un familier équipé pour le retirer.",
  'pets.slots': "Équipés",
  'pets.locked': "en même temps que le mode Monstres",
  'shotfx.hint': "Purement cosmétique : un effet volumineux qui se superpose à toutes tes armes (flash de bouche, traînée, explosion à l'impact). Boutique uniquement.",
  'hubshop.title': "Boutique du hub",
  'hubshop.tab.fx': "FX",
  'hubshop.tab.fireworks': "Feux d'artifice",
  'fireworks.hint': "Purement cosmétique : choisis le feu d'artifice lancé depuis le hub. Le « Classique » reprend les couleurs de ta munition.",
  'hub.catnip': "Herbe à chat",
  'hub.link.connected': 'En ligne',
  'hub.link.connecting': 'Connexion…',
  'hub.link.solo': 'Hors ligne',
  'fx.hint': "Purement cosmétique : une aura qui entoure ton chat en permanence. Boutique uniquement.",
  'fx.none': "Aucune",
  'hub.zoomIn': "Zoom +",
  'hub.zoomOut': "Zoom −",
  'hub.zoomReset': "RAZ",
  'hub.stow': "Ranger l'arme",
  'hub.unstow': "Sortir l'arme",
  'hub.firework': "Feu d'artifice",
  'hub.fx': "FX",
  'hub.shop': "Boutique skins",
  'ammo.hint': "Purement cosmétique : choisis l'apparence des tirs, traînées et impacts de chaque type d'arme.",
  'result.rewards': "Récompenses",
  'menu.online': "En ligne",
  'online.title': "En ligne",
  'online.tab.boards': "Classements",
  'online.tab.friends': "Amis",
  'online.tab.mail': "Courrier",
  'online.tab.events': "Événements",
  'online.offline': "Tu es hors ligne. Classements, amis, courrier et événements demandent une connexion.",
  'online.retry': "Réessayer",
  'online.refresh': "Actualiser",
  'online.loading': "Chargement…",
  'online.empty': "Rien pour l'instant.",
  'online.nick.label': "Pseudo",
  'online.nick.save': "Enregistrer",
  'online.nick.saved': "Pseudo enregistré",
  'online.nick.hint': "3 à 24 lettres, chiffres, - ou _. Les autres joueurs le voient.",
  'online.board.best_stage': "Meilleur stage",
  'online.board.boss_level': "Boss : victoires",
  'online.board.raid_level': "Raid : niveau",
  'online.board.catnip_weekly': "Herbe à chat (semaine)",
  'online.board.you': "Toi",
  'online.board.noScore': "Pas encore de score",
  'online.board.resets': "Remise à zéro dans {time}",
  'online.friend.add': "Ajouter un ami",
  'online.friend.placeholder': "Son pseudo",
  'online.friend.addBtn': "Ajouter",
  'online.friend.sent': "Invitation envoyée",
  'online.friend.added': "Vous êtes maintenant amis",
  'online.friend.accept': "Accepter",
  'online.friend.remove': "Retirer",
  'online.friend.join': "Rejoindre",
  'online.friend.requests': "Demandes",
  'online.friend.pending': "En attente de réponse",
  'online.friend.list': "Amis",
  'online.friend.on': "en ligne",
  'online.friend.off': "hors ligne",
  'online.mail.claim': "Récupérer",
  'online.mail.delete': "Supprimer",
  'online.mail.from': "De {name}",
  'online.mail.empty': "Ta boîte aux lettres est vide.",
  'online.event.ongoing': "En cours",
  'online.event.upcoming': "Bientôt",
  'online.event.ends': "Se termine dans {time}",
  'online.event.starts': "Commence dans {time}",
  'online.event.claim': "Récupérer la récompense",
  'online.event.claimed': "Récompense récupérée",
  'online.event.multiplier': "Herbe à chat x{n}",
  'online.event.reward': "Récompense : {reward}",
  'online.event.progress': "{n} / {max}",
  'online.shop.title': "Boutique d'événement",
  'online.shop.buy': "Acheter",
  'online.shop.balance': "Ton herbe à chat : {n}",
  'online.shop.empty': "La boutique s'ouvre pendant les événements spéciaux.",
  'online.shop.left': "{n} restant(s)",
  'online.offer.weekend_pack': "Pack du week-end",
  'online.offer.weekend_epic': "Tirage épique du week-end",
  'online.rewardReceived': "Récompense reçue !",
  'online.friendNotInHub': "Cet ami n'est pas dans un salon public du hub : tu as rejoint un salon normal.",
  'online.reportSent': "Signalement envoyé, merci.",
  'online.err.generic': "Une erreur est survenue.",
  'online.err.offline': "Tu es hors ligne.",
  'online.err.network': "Problème de connexion, réessaie.",
  'online.err.timeout': "Le serveur répond lentement, réessaie.",
  'online.err.username_taken': "Ce pseudo est déjà pris.",
  'online.err.bad_request': "Cette valeur n'est pas autorisée.",
  'online.err.rate_limited': "Trop vite, patiente un instant.",
  'online.err.insufficient_funds': "Pas assez d'herbe à chat.",
  'online.err.limit_reached': "Tu as atteint la limite de cette offre.",
  'online.err.not_found': "Joueur introuvable.",
  'online.err.already_claimed': "Déjà récupéré.",
  'online.err.goal_not_reached': "Objectif pas encore atteint.",
  'online.err.event_inactive': "Cet événement est terminé.",
  'online.err.forbidden': "Indisponible pour le moment.",
  'online.err.friend_limit': "Ta liste d'amis est pleine.",
  'hub.chat': "Discussion",
  'hub.emotes': "Emotes",
  'hub.players': "Joueurs",
  'hub.chat.placeholder': "Dis quelque chose…",
  'hub.chat.send': "Envoyer",
  'hub.chat.empty': "Pas encore de message. Dis bonjour !",
  'hub.chat.offline': "La discussion fonctionne quand tu es en ligne dans le hub.",
  'hub.chat.block': "Bloquer",
  'hub.chat.report': "Signaler",
  'hub.chat.addFriend': "Ajouter en ami",
  'hub.emote.wave': "Salut",
  'hub.emote.heart': "Amour",
  'hub.emote.laugh': "Rire",
  'hub.emote.dance': "Danse",
  'hub.emote.sleep': "Dodo",
  'hub.emote.angry': "Colère",
  'hud.bossLevel': "Niv. {n}",
  'hud.bossPhase': "Phase {n}/{max}",
  'hud.bossShield': "Carapace : {n} pylône(s)",
  'hud.raidEggs': "{n} œuf(s) à détruire",
  'hud.bossShieldUp': "Carapace ! Brise les pylônes",
  'hud.bossPhaseUp': "Phase {n}/{max}",
  'mode.result.score': "Score {n}",
  'raid.hatch': "Un œuf a éclos et soigne le dragon !",
  'modes.level': "Niveau {n}",
  'modes.bossHint': "Brise les pylônes de cristal pour faire tomber la carapace. Victoire rapide = meilleures récompenses.",
  'modes.raidHint': "Détruis les œufs du dragon avant qu'ils n'éclosent et ne le soignent.",
};
